import React, { useEffect } from "react";
import { Box, Stack, Typography } from "@mui/joy";
import Logo from "../../assets/svgs/logo.svg";

const SubmissionComplete = () => {
  const applicantData = JSON.parse(localStorage.getItem("applicantData") || "{}");

  return (
    <Box className="min-h-screen bg-[#F4F4F4] flex flex-col px-4 py-6 lg:px-10">
      <Box className="max-w-2xl mx-auto w-full">
        <Box className="mb-3">
          <img src={Logo} alt="logo" className="w-20 h-auto" />
        </Box>
        <Stack spacing={1}>
          <Typography
            level="h2"
            sx={{
              fontSize: { xs: "1.5rem", lg: "1.875rem" },
              fontWeight: 600,
              color: "#1A1B1D",
              mb: 1.5,
            }}
          >
            Thank you, {applicantData?.fullName || "Friend"}!
          </Typography>

          { applicantData?.employerName ? (
            <>
              <Typography
                sx={{
                  color: "#7B7F85",
                  fontSize: { xs: "1rem", lg: "1.125rem" },
                  mb: 1.5,
                }}
              >
                Your video is live on the {applicantData?.employerName} page!
              </Typography>
            </>
          ) : (
            <>
              <Typography
                sx={{
                  color: "#7B7F85",
                  fontSize: { xs: "1rem", lg: "1.125rem" },
                  mb: 1.5,
                }}
              >
                Your video is live!
              </Typography>
            </>
          )} 
        </Stack>
      </Box>
    </Box>
  );
};

export default SubmissionComplete;
